const value = {
    join: {
      title: 'Приглашение в проект',
      welcome: 'Добро пожаловать в проект',
      toRole: 'Вы — {{role}}.',
      eduDescription:
        'Здесь вы узнаете, как разработать его безопасным. Мы отметим обязательными юниты, которые помогут в работе, и оставим только нужное с учетом вашей роли.',
      reqDescription:
        'Здесь собраны требования, которые помогут разработать его безопасным. Вашу зону ответственности обозначит проектная роль.',
      reqEduDescription:
        'Здесь вы узнаете, как разработать его безопасным. Подобранные требования подскажут, что важно учесть, а обучающие материалы помогут в реализации. Вашу зону ответственности обозначит проектная роль',
      youAreInProject: 'Вы в проекте',
      joinBtn: 'Вступить',
      errorDuringJoining: 'Ошибка во вреия присоединения в проект',
      invitationNotFound: 'Приглашение не найдено',
    },
  };

export default value;
